(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("tenantTaxCountryResource", ["$resource", tenantTaxCountryResource]);
    function tenantTaxCountryResource($resource) {
        return $resource("/api/tenantTaxCountries/:id/:code/:action", { id: "@id" }, {
            getTaxListViewModel: {
                method: "GET",
                params: { action: "taxListViewModel" }
            },
            getTaxAddCountryViewModel: {
                method: "GET",
                params: { action: "taxAddCountryViewModel" }
            },
            getTaxFormCountryAndRegionsViewModel: {
                method: "GET",
                params: { action: "taxFormCountryAndRegionsViewModel" }
            },
            getTaxFormExternalProviderViewModel: {
                method: "GET",
                params: { action: "taxFormExternalProviderViewModel" }
            },
            update: {
                method: "PUT"
            },
            updateRegions: {
                method: "POST",
                params: { action: "updateRegions" }
            }
        });
    }
}());
